import React, { Component } from 'react'
import { Modal } from 'react-responsive-modal';
import { Vertify } from "@alex_xu/react-slider-vertify";
import { isDesktop } from 'react-device-detect';

export class SecurityModal extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {

    const recaptchaImg = this.imageImport(
      require.context(
        "../../assets/images/recaptcha/",
        false,
        /\.(png|jpe?g|svg)$/
      )
    );

    const imageStartingPoint = this.props.recaptcha_image_starting_point || 1;
    const imageUrl = recaptchaImg[`${imageStartingPoint}.jpg`];

    return (
      <Modal
        open={this.props.openSecurityModal}
        onClose={this.props.toggleSecurityModal}
        classNames={{
          overlay: 'customOverlay',
          modal: 'recaptcha-modal',
        }}
        center
      >
        <div className='modal-dialog'>
            <div className='modal-content'>
              <Vertify
                width={!isDesktop ? 720 : 320}
                height={!isDesktop ? 480 : 160}
                l={!isDesktop ? 84 : 30 }
                r={!isDesktop ? 18 : 8}
                visible={this.props.visible}
                id="recaptcha_status"
                name="recaptcha_status"
                // value={!this.props.formFilter.recaptcha_status}
                onSuccess={() => this.props.recaptchaSuccess("success")}
                onFail={() => this.props.recaptchaSuccess("failed")}
                onRefresh={() => this.props.recaptchaSuccess()}
                imgUrl={imageUrl}
              />
        </div>
        </div>
      </Modal>
    )
  }
}

export default SecurityModal